///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/helpers.ts" />
namespace TotalPoll {
    import Controller = TotalCore.Common.Controller;
    import Processable = TotalCore.Common.Processable;
    import ITimeoutService = angular.ITimeoutService;
    import IScope = angular.IScope;

    @Controller('controllers.totalpoll')
    export class OptionsCtrl extends Processable {
        public debug = this.RepositoryService.getDebugInformation();
        public import = {
            status: 'pending',
            content: ''
        };
        public migration = {
            plugins: this.RepositoryService.getMigrationPlugins()
        };
        public options = this.RepositoryService.getOptions();
        public expressions = {original: this.RepositoryService.getExpressions(), user: this.options.expressions || {}};
        public purging = {
            cache: 'pending'
        };

        constructor(private $scope: IScope, private $element, private RepositoryService: RepositoryService, private $timeout: ITimeoutService) {
            super();
            $scope.options = this.options;

            if (!this.options.expressions || angular.isArray(this.options.expressions)) {
                this.options.expressions = {};
                this.expressions.user = {};
            }

            //this.attachListenerToModels();
            this.prepareDragAndDrop();
        }

        attachListenerToModels() {
            let updateOption = (ngModel: any) => {
                ngModel.$$element.closest('.totalpoll-settings-field').addClass('totalpoll-processing');
                this.saveOptions();
            };
            angular.element(() => {
                angular.element('.totalpoll-settings-field [ng-model^="$ctrl.options"]').each((key, element: any) => {
                        let ngModel = angular.element(element).controller('ngModel');
                        if (ngModel) {
                            ngModel.$viewChangeListeners.push(() => {
                                if (ngModel.$$updateTimeout) {
                                    this.$timeout.cancel(ngModel.$$updateTimeout);
                                }

                                ngModel.$$updateTimeout = this.$timeout(
                                    () => updateOption(ngModel),
                                    500
                                );
                            });
                        }
                    }
                )
                ;
            });
        }

        downloadContent(filename, mimetype, content) {
            let link = document.createElement('a');
            link.download = filename;
            link.href = `data:${mimetype},${encodeURIComponent(content)}`;
            link.click();
        }

        downloadDebugInformation() {
            this.downloadContent('debug.json', 'application/json', JSON.stringify(this.debug));
        }

        downloadSettings() {
            this.downloadContent(`totalpoll-settings-${Date.now()}.json`, 'application/json', JSON.stringify(this.options));
        }

        getMigrationProgress(plugin) {
            return Number((plugin.done / plugin.total) * 100).toFixed(0) + '%';
        }

        hasPollsForMigration(plugin) {
            return plugin && (plugin.total - plugin.done) > 0;
        }

        importSettings() {
            this.import.status = 'processing';

            try {
                this.options = JSON.parse(this.import.content);
                this.$scope.options = this.options;

                this.saveOptions().finally(() => {
                    this.import.content = '';
                    this.import.status = 'done';
                    this.$timeout(() => this.import.status = 'pending', 3000);
                });
            } catch (e) {
                this.import.status = 'pending';
            }
        }

        isExpressionProcessing(expression) {
            return expression && expression.processing;
        }

        isExpressionSaved(expression) {
            return expression && expression.success;
        }

        isImportReady() {
            return this.import.content.length && this.import.status === 'pending';
        }

        isImported() {
            return this.import.status === 'done';
        }

        isImporting() {
            return this.import.status === 'processing';
        }

        isMigrationFinished(plugin) {
            return plugin && plugin.migrated;
        }

        isMigrationProcessing(plugin) {
            return plugin && plugin.processing;
        }

        isPurgeReady(type) {
            return this.purging[type] === 'pending';
        }

        isPurged(type) {
            return this.purging[type] === 'done';
        }

        isPurging(type) {
            return this.purging[type] === 'processing';
        }

        migratePolls(pluginId, plugin) {
            plugin.processing = true;
            plugin.done = plugin.done || 0;
            this.RepositoryService.postMigratePolls(pluginId)
                .then((result) => {
                    if (result.data.done >= result.data.of) {
                        plugin.done = plugin.total;
                        plugin.processing = false;
                        plugin.migrated = true;
                    } else {
                        plugin.done = result.data.done;
                        this.migratePolls(pluginId, plugin);
                    }
                });
        }

        prepareDragAndDrop() {
            let $textarea = this.$element.find('[tab="options>import-export"] textarea');

            $textarea.on('dragover', () => false);
            $textarea.on('dragend', () => false);
            $textarea.on('drop', (event) => {
                event.preventDefault();

                let file = event['originalEvent'].dataTransfer.files[0];
                let reader = new FileReader();

                if (file.type.indexOf('json') === -1) {
                    return;
                }

                reader.onload = (event) => {
                    this.$scope.$applyAsync(() => {
                        this.import.content = event['target']['result'];
                    });
                };
                reader.readAsText(file);

                return false;
            });
        }

        purge(type) {
            this.purging[type] = 'processing';
            this.RepositoryService.postPurge(type)
                .finally(() => {
                    this.purging[type] = 'done';

                    this.$timeout(
                        () => {
                            this.purging[type] = 'pending';
                        },
                        1000
                    );
                })
        }

        getStatus() {

        }

        saveOptions() {
            this.startProcessing();
            this.options.expressions = this.expressions.user;
            return this.RepositoryService.postOptions(JSON.stringify(this.options))
                .then((response) => {
                    if (!response.error) {
                        this.setProcessed(true);
                    }
                    this.$timeout(() => {
                        this.setProcessed(false);
                    }, 1000);

                    return response;
                })
                .catch((error) => {
                    this.setProcessed(false);
                    return error;
                })
                .finally(() => {
                    this.stopProcessing();
                })
        }
    }

}
